import React, { forwardRef, useMemo } from 'react';
import { v4 } from 'uuid';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';
import { Checkbox } from '../Checkbox/Checkbox.esm.js';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';

/**
 * A ListItem, expected to be used as children of `List`.
 */
const ListItem = forwardRef(({ addClassName = "", children, disabled = false, active = false, hasCheckbox = false, checked = false, indeterminate = false, iconLeft, iconRight, listItemStyle, dataMetrics, dataTestId, ...passThrough }, ref) => {
    const itemId = useMemo(() => `list-item-${v4()}`, []);
    const className = classNames("tw-box-border tw-flex tw-items-center tw-text-xs tw-py-2 tw-px-4 tw-space-x-1 tw-w-full", "tw-text-default dark:tw-text-dark-bg", disabled
        ? "tw-cursor-not-allowed tw-text-disabled dark:tw-text-dark-bg-disabled"
        : "hover:tw-bg-blue-100 active:tw-bg-blue-200 dark:active:tw-bg-gray-700 tw-cursor-pointer dark:hover:tw-bg-gray-800", active
        ? "tw-bg-blue-200 dark:tw-bg-gray-800"
        : "tw-bg-white dark:tw-bg-gray-1000", addClassName);
    return (React.createElement("li", { "data-metrics": `list-item-${itemId}`, "data-testid": `list-item-automation-${itemId}`, style: listItemStyle, className: className, ...{ disabled }, ...passThrough, ref: ref },
        hasCheckbox && (React.createElement(Checkbox, { dataMetrics: dataMetrics, dataTestId: dataTestId, "aria-labelledby": itemId, addClassName: "tw-flex-none", checked: checked, disabled: disabled, indeterminate: indeterminate, tabIndex: -1, onChange: noop })),
        iconLeft && React.createElement("span", { className: "tw-flex" }, iconLeft),
        React.createElement(TruncateText, { addClassName: "tw-flex-auto", id: itemId }, children),
        iconRight && React.createElement("span", { className: "tw-flex" }, iconRight)));
});
ListItem.displayName = "ListItem";

export { ListItem };
//# sourceMappingURL=ListItem.esm.js.map
